var map = {
	"./app.json": 19098,
	"./blog.json": 35643,
	"./components.json": 17943,
	"./contratos.json": 72108,
	"./conversionTable.json": 21089,
	"./currency.json": 49304,
	"./currencyBRL.json": 80856,
	"./currencyUSD.json": 7120,
	"./cxi-old.json": 46263,
	"./cxi.json": 19147,
	"./events.json": 75770,
	"./form.json": 49677,
	"./glossary.json": 72279,
	"./home.json": 20408,
	"./iframe.json": 4159,
	"./login.json": 56120,
	"./logout.json": 52161,
	"./matches.json": 17520,
	"./menu.json": 59036,
	"./news.json": 26536,
	"./notifications.json": 19145,
	"./oiweek.json": 3895,
	"./pages.json": 60893,
	"./profile.json": 11004,
	"./ranking-BKP.json": 9063,
	"./ranking.json": 18191,
	"./register.json": 18146,
	"./startup-cxi.json": 95139,
	"./startup.json": 33276,
	"./startupId.json": 94485,
	"./subscription.json": 98322,
	"./support.json": 85994,
	"./translation.json": 31726,
	"translations/pt/app.json": 19098,
	"translations/pt/blog.json": 35643,
	"translations/pt/components.json": 17943,
	"translations/pt/contratos.json": 72108,
	"translations/pt/conversionTable.json": 21089,
	"translations/pt/currency.json": 49304,
	"translations/pt/currencyBRL.json": 80856,
	"translations/pt/currencyUSD.json": 7120,
	"translations/pt/cxi-old.json": 46263,
	"translations/pt/cxi.json": 19147,
	"translations/pt/events.json": 75770,
	"translations/pt/form.json": 49677,
	"translations/pt/glossary.json": 72279,
	"translations/pt/home.json": 20408,
	"translations/pt/iframe.json": 4159,
	"translations/pt/login.json": 56120,
	"translations/pt/logout.json": 52161,
	"translations/pt/matches.json": 17520,
	"translations/pt/menu.json": 59036,
	"translations/pt/news.json": 26536,
	"translations/pt/notifications.json": 19145,
	"translations/pt/oiweek.json": 3895,
	"translations/pt/pages.json": 60893,
	"translations/pt/profile.json": 11004,
	"translations/pt/ranking-BKP.json": 9063,
	"translations/pt/ranking.json": 18191,
	"translations/pt/register.json": 18146,
	"translations/pt/startup-cxi.json": 95139,
	"translations/pt/startup.json": 33276,
	"translations/pt/startupId.json": 94485,
	"translations/pt/subscription.json": 98322,
	"translations/pt/support.json": 85994,
	"translations/pt/translation.json": 31726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51739;